<template>
    <group-details :groupId="props.groupId">
        <contact-list :groupId="props.groupId" withoutOverview class="col-span-12 lg:col-span-10"></contact-list>
    </group-details>
</template>

<script setup>
import GroupDetails from './GroupDetails.vue';
import ContactList from '~/components/contacts/contact/ContactList.vue';

const props = defineProps({
    groupId: {
        type: String,
        required: true,
    }
});
</script>
